import React from 'react'
import DropdownWithoutPreventScroll from '../uiKit/DropdownWithoutPreventScroll'
import Button from '../uiKit/Button'
import Icon from '../misc/Icons'
import DropdownSelect from '../uiKit/DropdownSelect'
import DropdownDivider from '../uiKit/DropdownDivider'
import DropdownSelectItem from '../uiKit/DropdownSelectItem'

//TODO clean this up

class LiveViewDropdown extends React.Component{	


	setStudentSortOrder(sortOrder){
		const liveViewSettings = JSON.parse(localStorage.getItem('liveViewSettings'))
		let newliveViewSettings
		if(liveViewSettings){
			newliveViewSettings={...liveViewSettings,studentSortOrder:sortOrder}
		}else{
			newliveViewSettings={studentSortOrder:sortOrder}
		}
		localStorage.setItem('liveViewSettings', JSON.stringify(newliveViewSettings))

	}


	setStudentListVisibility(visibility){
		const liveViewSettings = JSON.parse(localStorage.getItem('liveViewSettings'))
		let newliveViewSettings
		if(liveViewSettings){
			newliveViewSettings={...liveViewSettings,studentListVisible:visibility}
		}else{
			newliveViewSettings={studentListVisible:visibility}
		}
		localStorage.setItem('liveViewSettings', JSON.stringify(newliveViewSettings))

	}



	setAlwaysShowControls(alwaysShow){
		const liveViewSettings = JSON.parse(localStorage.getItem('liveViewSettings'))
		let newliveViewSettings
		if(liveViewSettings){
			newliveViewSettings={...liveViewSettings,alwaysShowControls:alwaysShow}
		}else{
			newliveViewSettings={alwaysShowControls:alwaysShow}
		}
		localStorage.setItem('liveViewSettings', JSON.stringify(newliveViewSettings))

	}

	setAlwaysShowLetterblock(alwaysShowLetterblock){
		const liveViewSettings = JSON.parse(localStorage.getItem('liveViewSettings'))
		let newliveViewSettings
		if(liveViewSettings){
			newliveViewSettings={...liveViewSettings,alwaysShowLetterblock:alwaysShowLetterblock}
		}else{
			newliveViewSettings={alwaysShowLetterblock:alwaysShowLetterblock}
		}
		localStorage.setItem('liveViewSettings', JSON.stringify(newliveViewSettings))

	}
	setShowStudentCardNumbers(showStudentCardNumbers){
		const liveViewSettings = JSON.parse(localStorage.getItem('liveViewSettings'))
		let newliveViewSettings
		if(liveViewSettings){
			newliveViewSettings={...liveViewSettings,showStudentCardNumbers:showStudentCardNumbers}
		}else{
			newliveViewSettings={showStudentCardNumbers:showStudentCardNumbers}
		}
		localStorage.setItem('liveViewSettings', JSON.stringify(newliveViewSettings))

	}

	setColorScheme(scheme){
		const liveViewSettings = JSON.parse(localStorage.getItem('liveViewSettings'))
		let newliveViewSettings
		if(liveViewSettings){
			newliveViewSettings={...liveViewSettings,colorScheme:scheme}
		}else{
			newliveViewSettings={colorScheme:scheme}
		}
		localStorage.setItem('liveViewSettings', JSON.stringify(newliveViewSettings))

	}
	setAlwaysShowGraph(alwaysShow){
		const liveViewSettings = JSON.parse(localStorage.getItem('liveViewSettings'))
		let newliveViewSettings
		if(liveViewSettings){
			newliveViewSettings={...liveViewSettings,alwaysShowGraph:alwaysShow}
		}else{
			newliveViewSettings={alwaysShowGraph:alwaysShow}
		}
		localStorage.setItem('liveViewSettings', JSON.stringify(newliveViewSettings))

	}

	setShowIndividualResponses(setting){
		const liveViewSettings = JSON.parse(localStorage.getItem('liveViewSettings'))
		let newliveViewSettings
		if(liveViewSettings){
			newliveViewSettings={...liveViewSettings,showIndividualResponses:setting}
		}else{
			newliveViewSettings={showIndividualResponses:setting}
		}
		localStorage.setItem('liveViewSettings', JSON.stringify(newliveViewSettings))
	}
	setShowResponseCounts(show){
		const liveViewSettings = JSON.parse(localStorage.getItem('liveViewSettings'))
		let newliveViewSettings
		if(liveViewSettings){
			newliveViewSettings={...liveViewSettings,showResponseCounts:show}
		}else{
			newliveViewSettings={showResponseCounts:show}
		}
		localStorage.setItem('liveViewSettings', JSON.stringify(newliveViewSettings))
	}



	render(){
		let studentSortOrder='name'
		let studentListVisible='scan'
		//let alwaysShowControls=true
		let alwaysShowLetterblock=false
		let showStudentCardNumbers=false
		let colorScheme='scheme1'
		let alwaysShowGraph=false
		let showIndividualResponses='never'
		let showResponseCounts=false

		const liveViewSettings = JSON.parse(localStorage.getItem('liveViewSettings'))
	
		if(liveViewSettings ){
			if(liveViewSettings.studentSortOrder){
				studentSortOrder=liveViewSettings.studentSortOrder
			}
			if(liveViewSettings.studentListVisible){
				studentListVisible=liveViewSettings.studentListVisible
			}
			// if(liveViewSettings.alwaysShowControls || !liveViewSettings.alwaysShowControls ){
			
			// 	alwaysShowControls=liveViewSettings.alwaysShowControls
			
			// }
			if(liveViewSettings.alwaysShowLetterblock){
				alwaysShowLetterblock=liveViewSettings.alwaysShowLetterblock
			}
			if(liveViewSettings.showStudentCardNumbers){
				showStudentCardNumbers=liveViewSettings.showStudentCardNumbers
			}
			if(liveViewSettings.colorScheme){
				colorScheme=liveViewSettings.colorScheme
			}
			if(liveViewSettings.alwaysShowGraph){
				alwaysShowGraph=liveViewSettings.alwaysShowGraph
			}
			if(liveViewSettings.showIndividualResponses){
				showIndividualResponses=liveViewSettings.showIndividualResponses
			}
			if(liveViewSettings.showResponseCounts){
				showResponseCounts=liveViewSettings.showResponseCounts
			}

		}

		return(

			<React.Fragment>
		

			<DropdownWithoutPreventScroll dropdownButton={<Button iconName='student-list-settings' label='Student List' size='large' />} >        	   
				
				<DropdownSelect label='Show Student List'>
					<DropdownSelectItem isActive={studentListVisible==='never'} label='Never Display' onSelect={()=>{this.setStudentListVisibility('never')}}/>
					<DropdownSelectItem isActive={studentListVisible==='scan'} label='Display while Scanning' onSelect={()=>{this.setStudentListVisibility('scan')}}/>
					<DropdownSelectItem isActive={studentListVisible==='always'} label='Always Display' onSelect={()=>{this.setStudentListVisibility('always')}}/>
				</DropdownSelect>

				<DropdownDivider /> 									

				<DropdownSelect label='Sort Student List by'>
					<DropdownSelectItem isActive={studentSortOrder==='name'} label='Name' onSelect={()=>{this.setStudentSortOrder('name')}}/>
					<DropdownSelectItem isActive={studentSortOrder==='card'} label='Card Number' onSelect={()=>{this.setStudentSortOrder('card')}}/>
				</DropdownSelect>
															
				<DropdownDivider /> 

				<DropdownSelect label='Student Card Numbers'>					
					<DropdownSelectItem isActive={!showStudentCardNumbers} label='Hide' onSelect={()=>{this.setShowStudentCardNumbers(false)}}/>
					<DropdownSelectItem isActive={showStudentCardNumbers}label='Show' onSelect={()=>{this.setShowStudentCardNumbers(true)}}/>										
				</DropdownSelect>

				<DropdownDivider />

				<DropdownSelect label='Individual Responses'>
					<DropdownSelectItem isActive={showIndividualResponses==='never'}label='Hide' onSelect={()=>{this.setShowIndividualResponses('never')}}/>
					{/*<DropdownSelectItem isActive={showIndividualResponses==='manual'} label='Manually (Show Button)' onSelect={()=>{this.setShowIndividualResponses('manual')}}/> */}
					<DropdownSelectItem isActive={showIndividualResponses==='always'}label='Show' onSelect={()=>{this.setShowIndividualResponses('always')}}/>										
				</DropdownSelect>
					
			</DropdownWithoutPreventScroll>

			<DropdownWithoutPreventScroll dropdownButton={<Button iconName='cog' label='Display Options' size='large' />} >        	   
				
				<DropdownSelect label='Show Graph'>
					<DropdownSelectItem isActive={!alwaysShowGraph} label='Manually (Show Button)' onSelect={()=>{this.setAlwaysShowGraph(false)}}/>
					<DropdownSelectItem isActive={alwaysShowGraph}label='Always' onSelect={()=>{this.setAlwaysShowGraph(true)}}/>
				</DropdownSelect>				

				<DropdownDivider /> 
				
				<DropdownSelect label='Incorrect Choice Color'>	
					<DropdownSelectItem isActive={colorScheme==='scheme1'} label='Gray' onSelect={()=>{this.setColorScheme('scheme1')}}/>
					<DropdownSelectItem isActive={colorScheme==='scheme2'} label='Red' onSelect={()=>{this.setColorScheme('scheme2')}}/>
				</DropdownSelect>		
				
				<DropdownDivider /> 

				<DropdownSelect label='Answer Display'>
					<DropdownSelectItem isActive={!alwaysShowLetterblock} label='Show Check and Cross' onSelect={()=>{this.setAlwaysShowLetterblock(false)}}/>
					<DropdownSelectItem isActive={alwaysShowLetterblock}label='Show Choice Letter' onSelect={()=>{this.setAlwaysShowLetterblock(true)}}/>
				</DropdownSelect>	

				<DropdownDivider /> 

				<DropdownSelect label='Show Response Counts'>
					<DropdownSelectItem isActive={showResponseCounts} label='Show' onSelect={()=>{this.setShowResponseCounts(true)}}/>
					<DropdownSelectItem isActive={!showResponseCounts}label='Hide' onSelect={()=>{this.setShowResponseCounts(false)}}/>
				</DropdownSelect>	


			</DropdownWithoutPreventScroll>

			</React.Fragment>			

		)
	}
}

export default LiveViewDropdown
